import { withFormElement } from "@brynlabs/webforms-react"
import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

import "./textarea.sass"

class Textarea extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      value: props.value || "",
    }
  }

  onChange(ev) {
    const value = ev.target.value || ""
    this.setState({ value })
    if (this.props.onChange) {
      this.props.onChange(value)
    }
  }

  render() {
    const {
      darkAppearance,
      titleTranslatedString,
      name,
      value,
      onChange,
      disabled,
      required = false,
      ...props
    } = this.props
    return (
      <div className={"_fp-textarea"}>
        <textarea
          {...props}
          onChange={(ev) => this.onChange(ev)}
          value={this.state.value}
          rows={5}
          name={name || titleTranslatedString}
          required={required}
          className={classNames("_fp-textarea__input", {
            "_fp-textarea__input--dark": darkAppearance,
          })}
        ></textarea>
      </div>
    )
  }
}

Textarea.propTypes = {
  darkAppearance: PropTypes.bool,
  titleTranslatedString: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
}

const WebformsTextarea = withFormElement(({ setData, getData, ...props }) => {
  return (
    <Textarea
      {...props}
      onChange={(value) => setData(value)}
      value={getData()}
    />
  )
})

export { Textarea, WebformsTextarea }
